const routes = {
  home: '/',
  register: '/register',
  login: '/login',
  calculator: '/calculator',
  diary: '/diary',
};

export default routes;
